var _jsxFileName = "/codebuild/output/src4245919257/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/register/VerifyEmail.tsx";
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { LoadingModal, Stack, Text } from '@adc/parallax-component-library';
import { ApiStatus } from 'Constants';
import { useApiError } from 'Hooks';
import { MainContainer, ThemedImage } from 'Components/utility';
import i18n from 'Utilities/i18n';
import { verifyEmail } from 'Services/auth';
const mapStateToProps = ({
  env: {
    osType,
    osVersion,
    app,
    appVersion
  },
  nav: {
    query: {
      token
    }
  }
}) => {
  return {
    osType,
    osVersion,
    app,
    appVersion,
    token
  };
};
const connector = connect(mapStateToProps);
const VerifyEmail = ({
  osType,
  osVersion,
  app,
  appVersion,
  token
}) => {
  const [loading, setLoading] = useState(true);
  const [expired, setExpired] = useState(false);
  const isLLU = app === 'llu';
  const {
    showApiErrorModal
  } = useApiError();
  const resourceKey = isLLU ? 'Global.microcopy.common.libreLinkUpLogoLight' : 'Global.microcopy.common.libreViewLogoLight';
  useEffect(() => {
    (async () => {
      if (!token) {
        return;
      }
      try {
        await verifyEmail(token, osType, osVersion, app, appVersion);
      } catch (err) {
        var _error$response, _error$response2;
        const error = err;
        const status = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status;
        const code = (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data.code;
        if (status === ApiStatus.GONE && code === ApiStatus.EXPIRED_EMAIL_TOKEN) {
          setExpired(true);
          return;
        }
        showApiErrorModal();
      } finally {
        setLoading(false);
      }
    })();
  }, [app, appVersion, osType, osVersion, showApiErrorModal, token]);
  if (loading) {
    return /*#__PURE__*/React.createElement(LoadingModal, {
      "aria-label": "loading",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 72,
        columnNumber: 12
      }
    });
  }
  return /*#__PURE__*/React.createElement(MainContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    padding: '$4',
    marginTop: "$5",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(ThemedImage, {
    resourceKey: resourceKey,
    alt: "",
    id: resourceKey,
    style: {
      height: '40px',
      objectFit: 'contain'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 9
    }
  }), !expired ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack, {
    marginTop: "$12",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: i18n.t('EmailConfirmed.content.emailConfirmedImg.media.emailConfirmed'),
    alt: "",
    style: {
      objectFit: 'contain',
      height: 80
    },
    id: "EmailConfirmed.checkEmail.media",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement(Stack, {
    gap: "$3",
    marginTop: "$7",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 102,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Text, {
    color: "$text.100",
    type: "$h2.strong",
    textAlign: "center",
    testID: "EmailConfirmed.title",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 15
    }
  }, i18n.t('EmailConfirmed.title')), /*#__PURE__*/React.createElement(Text, {
    color: "$text.100",
    type: "$bodyBase.default",
    textAlign: "center",
    testID: "EmailConfirmed.subtitle",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 15
    }
  }, i18n.t('EmailConfirmed.subtitle')))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack, {
    marginTop: "$12",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 123,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(ThemedImage, {
    resourceKey: "ResetPasswordFailure.content.resetPasswordFailureContent.media.pwResetLockLight",
    alt: "password reset failure illustration",
    id: "ResetPasswordFailure.content.resetPasswordFailureContent.media.pwResetLock",
    style: {
      marginTop: '40px',
      height: '105px',
      objectFit: 'contain'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 124,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement(Text, {
    nativeID: "ResetPasswordFailure.content.resetPasswordFailureContent.primaryText",
    testID: "ResetPasswordFailure.content.resetPasswordFailureContent.primaryText",
    fontWeight: '$h2.medium',
    fontSize: "$h2.medium",
    color: "$text.100",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 135,
      columnNumber: 13
    }
  }, i18n.t('ResetPasswordFailure.content.resetPasswordFailureContent.primaryText')), /*#__PURE__*/React.createElement(Text, {
    nativeID: "ResetPasswordFailure.content.resetPasswordFailureContent.secondaryText",
    testID: "ResetPasswordFailure.content.resetPasswordFailureContent.secondaryText",
    color: "$text.100",
    textAlign: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 149,
      columnNumber: 13
    }
  }, i18n.t('ResetPasswordFailure.content.resetPasswordFailureContent.secondaryText')))));
};
export default connector(VerifyEmail);